import {
  Component,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  inject
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonContent, MenuController, Platform } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { map, filter, take } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { CoreRouterActionNavigateToPageModule } from '../../core-router.actions';
import { SharedPopupService } from '@bepatient/shared';
import { CoreUtilsService } from '../../core-utils';
import {
  CoreActionLogout,
  CoreActionNavigateToResource,
  CoreActionLoadMenu,
  CoreActionSetMenuReloadRequired
} from '../../core.actions';
import {
  selectorCoreMenu,
  selectorCoreUser,
  selectorCoreInstanceInfo,
  selectorCoreMenuReloadRequired
} from '../../core.reducer';
import {
  improveCoreMenu,
  ImprovedCoreMenuButton
} from './app-dynamic-menu.utils';
import { SplashScreen } from '@capacitor/splash-screen';
import { CorePopupService } from '../../core-popup.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-root',
  templateUrl: './app-dynamic-menu.component.html',
  styleUrls: ['./app-dynamic-menu.component.scss'],
  standalone: false
})
export class CoreAppDynamicMenuComponent implements OnChanges {
  sanitizer = inject(DomSanitizer);
  private store = inject<Store<any>>(Store);
  private menuController = inject(MenuController);
  viewContainerRef = inject(ViewContainerRef);
  private corePopupService = inject(CorePopupService);
  private platform = inject(Platform);
  private coreUtilsService = inject(CoreUtilsService);
  private sharedPopupService = inject(SharedPopupService);

  @ViewChild('leftMenuContent', { static: true })
  private leftMenuContent: IonContent;
  platformType = '';

  ngOnChanges(_changes: SimpleChanges): void {}

  ngAfterViewChecked() {
    if (!(this.platform.is('android') || this.platform.is('ios'))) {
      this.store
        .pipe(select(selectorCoreMenuReloadRequired), take(1))
        .subscribe(required => {
          if (required) {
            this.store.dispatch(new CoreActionLoadMenu());
            this.store.dispatch(new CoreActionSetMenuReloadRequired(false));
          }
        });
    }
  }

  get isWebview(): boolean {
    return !(this.platform.is('android') || this.platform.is('ios'));
  }

  userIsLogged$ = this.store.pipe(
    select(selectorCoreUser),
    map(user => !!user)
  );
  improvedMenu$ = this.store.pipe(select(selectorCoreMenu), improveCoreMenu());

  scrollMenu = false;
  selectedMenuButton: any;
  getinputInfo = false;

  constructor() {
    this.improvedMenu$.subscribe(() => (this.scrollMenu = true));
  }

  ionViewDidEnter() {
    SplashScreen.hide();

    if (this.corePopupService) {
      this.corePopupService.popupServiceRef = this.viewContainerRef;
    }
    this.platformType = Capacitor.getPlatform();
  }

  menuWillOpen(): void {
    if (this.scrollMenu && this.leftMenuContent) {
      this.scrollMenu = false;
      this.leftMenuContent.scrollToTop();
    }
  }

  menuWillClose(): void {}

  menuButton(input: any): void {
    this.menuController.close('leftMenu').then(() => {
      if (input.action === 'LOGOUT') {
        this.store.dispatch(new CoreActionLogout());
      } else if (input.module) {
        this.store.dispatch(
          new CoreRouterActionNavigateToPageModule({
            id: input.module,
            asRoot: true,
            pageIndex: input.pageIndex || 0
          })
        );
      } else if (input.resource) {
        this.store.dispatch(
          new CoreActionNavigateToResource({
            resource: input.resource,
            asRoot: true
          })
        );
      }
    });
  }

  menuButtonClick(button: any): void {
    this.selectedMenuButton = button;
    const improvedButton: ImprovedCoreMenuButton = button;
    this.store
      .pipe(
        select('myForm'),
        filter(val => val !== undefined)
      )
      .subscribe(isFormEditInfo => {
        this.getinputInfo = isFormEditInfo.isPageUpdated;
      })
      .unsubscribe();

    if (!this.getinputInfo) {
      this.menuButton(improvedButton);
    } else {
      this.createQuitPopup().then(index => {
        if (index === 1) {
          this.menuButton(improvedButton);
        }
      });
    }
  }

  private createQuitPopup(): Promise<number> {
    let quitPopup: Promise<number> = null;
    forkJoin([
      this.coreUtilsService.getSafeTranslations([
        'MY_FORM.ALERT_ACTION_BACK.HEADER',
        'MY_FORM.ALERT_ACTION_BACK.MESSAGE',
        'MY_FORM.ALERT_ACTION_BACK.CANCEL',
        'MY_FORM.ALERT_ACTION_BACK.OK'
      ]),
      this.store.select(selectorCoreInstanceInfo).pipe(take(1))
    ]).subscribe(([translations, instanceInfo]) => {
      quitPopup = this.sharedPopupService.simpleAlert({
        color: instanceInfo && instanceInfo.appColor,
        title: translations[0],
        message: translations[1],
        buttons: [translations[2], translations[3]]
      });
    });
    return quitPopup;
  }
}
